import React from 'react';
import styled from 'styled-components';

/**
 * Divider Component - Horizontal line separator
 *
 * @param {Object} props
 * @param {string} [props.color] - Custom color for the divider
 * @param {string} [props.height='1px'] - Height of the divider
 * @param {string} [props.margin='24px 0'] - Margin around the divider
 * @param {string} [props.width='100%'] - Width of the divider
 * @param {string} [props.className] - Additional CSS class
 */
const Divider = ({ color, height = '1px', margin = '24px 0', width = '100%', className }) => {
  return <DividerLine $color={color} $height={height} $margin={margin} $width={width} className={className} />;
};

const DividerLine = styled.hr`
  /* Layout */
  width: ${props => props.$width};
  height: ${props => props.$height};
  border: none;
  margin: ${props => props.$margin};

  /* Color */
  background-color: ${props => props.$color || 'rgba(69, 68, 107, 0.2)'};

  /* Remove default styles */
  outline: none;
`;

export default Divider;
